import { IBlockDefinition, IBlockProps, SWIFT_PREDICT_BLOCK_TYPE } from '@fox/blocks';
import { ConditionalRichTextBlockRuntime } from './rich-text-block';

/**@deprecated The swiftpredict block does exactly the same as the rich-text block. We keep this around to ensure existing forms using this will still render this block */
export const ConditionalSwiftPredictBlockRuntime: IBlockDefinition<IBlockProps> = {
	...ConditionalRichTextBlockRuntime,
	type: SWIFT_PREDICT_BLOCK_TYPE
};
